import csatEmployersType from './action-types'
import { FetchCsatEmployersPayload } from './types'

export const fetchCsatEmployers = ({ options }: { options: FetchCsatEmployersPayload }) => ({
  type: csatEmployersType.ENTITIES_FETCH_BEGIN,
  options,
})

export type FetchCsatEmployersAction = ReturnType<typeof fetchCsatEmployers>
